import {
  jurisdictionAllSwiperSettings, jurisdictionGamesSwiperSettings, newsSwiperSettings,
  partnersSwiperSetting,
  swiperAwardsSetting,
  swiperProductSettings,
} from './swiperSettings';
import {generateSlider} from './generateSwiper';

const pages = () => {
  /*
   * SELECTORS
   */
  let filterItems = document.querySelectorAll('.filter-jurisdictions li');
  let ham = document.querySelector('header .hamburger-menu');
  let mobileMenu = document.querySelector('.mobile-menu');
  let activeClass = document.querySelector('.filter-jurisdictions .active');

  /*
   * EVENTS
   */
  const manageCountryHighlightingAndFilters = function () {
    const highlightCountriesByAttribute = function (array, attr = 'all') {
      let activeClassOnLoadAttr = activeClass.getAttribute(`data-${attr}`);
      array.forEach((el) => {
        if (el.getAttribute(`data-${activeClassOnLoadAttr}`)) {
          el.style.fill = '#E42314';
        }
      })
    }
    const highlightSpecificCountry = (elements, attr) => {
      elements.forEach((el) => {
        el.style.fill = '#EEEEEE'; // Default color
        if (el.getAttribute(`data-${attr}`)) {
          el.style.fill = '#E42314'; // Highlight color
        }
      });
    };
    const toggleCountryBoxesByAttribute = (attr) => {
      const countryBoxes = document.querySelectorAll('.jurisdictions .box');
      countryBoxes.forEach((box) => {
        box.classList.toggle('active-box', attr === box.getAttribute('data-all'));
      });
    };
    const updateActiveFilterOnClick = () => {
      filterItems.forEach((filterItem) => {
        filterItem.addEventListener('click', (e) => {
          filterItems.forEach((item) => item.classList.remove('active'));
          e.target.classList.add('active');

          const dataAttributeKey = Object.keys(e.target.dataset)[0];
          highlightSpecificCountry(document.querySelectorAll('.jurisdictions svg path'), dataAttributeKey);
          toggleCountryBoxesByAttribute(dataAttributeKey);
        });
      });
    };

    highlightCountriesByAttribute(document.querySelectorAll('.jurisdictions svg path'))
    updateActiveFilterOnClick();
  };

  const toggleFilterMenuJurisdictions = (activeClass, filterSelector) => {
    const filterItems = document.querySelectorAll(filterSelector);
    const topElement = document.querySelector('.top .text');
    topElement.textContent = activeClass.textContent;

    filterItems.forEach((filterItem) => {
      filterItem.addEventListener('click', (e) => {
        topElement.textContent = e.target.textContent;
        const filterContainer = e.target.closest('.filter-jurisdictions');
        filterContainer.classList.remove('toggle-filter');
      });
    });

    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('top')) {
        const filterContainer = e.target.closest('.filter-jurisdictions');
        filterContainer.classList.toggle('toggle-filter');
      }
    });
  };
  function toggleHeaderOnScrollv2() {
    const filter = document.querySelector('.product-filter');
    const header = document.querySelector('header');
    let lastScrollTop = 0;
    let headerHidden = false;


    const topOffset = header.getBoundingClientRect().height;
    const filterTop = filter ? filter.getBoundingClientRect().top + window.pageYOffset : null;

    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollThreshold = 10; // This defines the minimum scroll distance to trigger the show/hide behavior

      const shouldHideHeader = filter ?
        (scrollTop >= filterTop && scrollTop > lastScrollTop + scrollThreshold) :
        scrollTop > lastScrollTop + scrollThreshold;

      const shouldShowHeader = filter ?
        (scrollTop < lastScrollTop - scrollThreshold) :
        scrollTop < lastScrollTop - scrollThreshold;

      if (shouldHideHeader && !headerHidden) {
        header.classList.add('hidden');
        headerHidden = true;
      } else if (shouldShowHeader && headerHidden) {
        header.classList.remove('hidden');
        headerHidden = false;
      }

      if (filter) {
          if (scrollTop + 10 >= filterTop - topOffset) {
            filter.classList.add('filter-fixed');
          } else if (scrollTop + 10 <= filterTop - topOffset) {
            filter.classList.remove('filter-fixed');
          }
          filter.classList.toggle('space-top', !headerHidden);
      }

      lastScrollTop = scrollTop;
    });


  }


  /*
   * ACTIONS
   */
  toggleHeaderOnScrollv2();

  if (ham) {
    ham.addEventListener('click', () => {
      ham.closest('header').querySelector('.ham').classList.toggle('active')
      mobileMenu.classList.toggle('show');
      if (mobileMenu.querySelector('.active')) {
        mobileMenu.querySelector('.active').classList.remove('active')
      }
      document.body.style.overflowY = document.querySelector('.mobile-menu.show') ? 'hidden' : 'auto';
    })
  }

  if (document.querySelectorAll('.jurisdictions').length > 0) {
    manageCountryHighlightingAndFilters();
    toggleFilterMenuJurisdictions(document.querySelector('.filter-jurisdictions .active'), '.filter-jurisdictions ul li');
  }
  if (document.querySelectorAll('.swiperPartners').length > 0) {
    generateSlider('.swiperPartners', partnersSwiperSetting);
  }
  if (document.querySelectorAll('.awardsSwiper').length > 0) {
    generateSlider('.awardsSwiper', swiperAwardsSetting);
  }
  if(document.querySelectorAll('.jurisdictionsSwiper').length > 0) {
    generateSlider('.jurisdictionsSwiper', jurisdictionAllSwiperSettings);
    generateSlider('.jurisdictionsGameSwiper', jurisdictionGamesSwiperSettings);
  }
  if (window.innerWidth < 1025) {
    let swiperProduct = document.querySelectorAll('.ourProducts .swiper-slide');
    swiperProduct.forEach((el) => {
      if (el.querySelector('.first-box')) {
        el.remove();
      }
    })
    generateSlider('.ourProducts', swiperProductSettings);
    generateSlider('.newsSwiper', newsSwiperSettings);
  }

  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
  /*
   * EXTRA EXPORTS
   */
};
export default pages;



// WEBPACK FOOTER //
// ./scripts/exports/pages.js